import { PageRef } from 'providers/page-ref';

export type AdminUserSearchPageParams = {
  query?: string;
};

export const IAdminUserSearchPage: PageRef<AdminUserSearchPageParams, void> = {
  pageName: 'AdminUserSearchPage',
} as PageRef<AdminUserSearchPageParams, void>;
